import React, { useContext } from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { Button } from "@domestika-dev/prudencio/dist/atoms/Buttons";
import { Camera } from "@domestika-dev/prudencio/dist/atoms/Icons";
import { IconForm } from "@domestika-dev/prudencio/dist/atoms/Icon";
import { TextForm } from "@domestika-dev/prudencio/dist/atoms/Typography";
import { LiveSessionContext } from "../../../context/LiveSessionContext";

export const PlayerGoLiveButton = ({ disabled }) => {
  const { onStartStreaming } = useContext(LiveSessionContext);
  return (
    <Button size="medium" action={onStartStreaming} disabled={disabled}>
      <IconForm marginRight={[2]} size={["tiny", "tiny", "small"]} color="coco">
        <Camera />
      </IconForm>
      <TextForm size={["tiny", "tiny", "small"]} fontWeight="medium" color="coco">
        <FormattedMessage id="live_sessions.video_player.go_live_button" />
      </TextForm>
    </Button>
  );
};

PlayerGoLiveButton.propTypes = {
  disabled: PropTypes.bool,
};

PlayerGoLiveButton.defaultProps = {
  disabled: false,
};

export default PlayerGoLiveButton;
